<template>
  <div class="copy-writing">
    <div class="copy-item">
      <p class="title title-text">
        <span>投保年龄</span>
        <span>18-65周岁</span>
      </p>
      <p class="title title-text">
        <span>保障区域</span>
        <span>中国境内（不含港澳台地区）</span>
      </p>
      <p class="title title-text">
        <span>保障期限</span>
        <span>1个月（投保后次日零时生效）</span>
      </p>
    </div>
    <div class="copy-item">
      <p class="title title-text">
        <span>医院范围</span>
      </p>
      <div class="copy-content">
        <p>国家卫生部医院等级分类中二级及以上公立医院或卫生健康委员会指定的新型冠状病毒感染的肺炎诊治定点医院</p>
      </div>
    </div>
    <div class="copy-item">
      <p class="title title-text">
        <span>特定传染病危重症疾病保险金</span>
        <span>最高1万</span>
      </p>
      <div class="copy-content">
        <p>在保险期间内，被保险人在等待期（5天）后经医院初次确诊罹患新型冠状病毒感染的肺炎，并达到《新型冠状病毒感染肺炎的诊疗方案（试行第四版）》中“临床分型”的危重型的，泰康在线依照保险合同给付特定传染病危重症疾病保险金，同时本项保险责任终止。</p>
        <p>《新型冠状病毒感染肺炎的诊疗方案（试行第四版）》中“临床分型”的危重型，须满足下列条件之一：</p>
        <p>1. 休克；</p>
        <p>2. 呼吸衰竭并使用机械通气</p>
        <p>3. 合并其他器官功能衰竭需ICU监护治疗。</p>
      </div>
    </div>
    <div class="copy-item">
      <p class="title title-text">
        <span>特定传染病身故保险金</span>
        <span v-text="`最高${deadAmount}万`"></span>
      </p>
      <div class="copy-content">
        <p>在保险期间内，被保险人在等待期（5天）后经医院初次确诊罹患新型冠状病毒感染的肺炎，并因该疾病导致身故的，泰康在线依照保险合同给付特定传染病身故保险金，同时保险合同终止。</p>
        <p>若被保险人身故前已领取保险合同约定的特定传染病危重症疾病保险金的，则给付特定传染病身故保险金时会扣减已给付的特定传染病危重症疾病保险金。</p>
      </div>
    </div>
    <div class="copy-item">
      <p class="title title-text">
        <span>理赔流程</span>
      </p>
      <div class="copy-content">
        <p style="font-weight: 500">第一步：报案申请</p>
        <p>【泰康在线保险】微信公众号→“我的服务”→“我要理赔”→根据提示填写信息并上传理赔影印件；
或拨打95522-3报案。；</p>
        <p style="font-weight: 500">第二步：受理</p>
        <p>24小时内受理，初步核实保险责任及申请资料；</p>
        <p style="font-weight: 500">第三步：提交理赔资料</p>
        <p>根据微信或短信提示邮寄理赔单证原件；</p>
        <p style="font-weight: 500">第四步：完成理赔</p>
        <p>核赔人员审核通过, 确定理赔金额后3个工作日内进行支付</p>
      </div>
    </div>
    <div class="copy-item">
      <p class="title title-text">
        <span>理赔资料</span>
      </p>
      <div class="copy-content">
        <p>保险金申请人向保险人申请给付保险金时，应提交以下材料。保险金申请人因特殊原因不能提供以下材料的，应提供其他合法有效的材料。保险金申请人未能提供有关材料，导致保险人无法核实该申请的真实性的，保险人对无法核实部分不承担给付保险金的责任。</p>
        <p>（1）保险金给付申请书；</p>
        <p>（2）保险合同或保单号；</p>
        <p>（3）保险金申请人的有效身份证件；</p>
        <p>（4）由医院专科医生出具的对被保险人的特定传染病、特定传染病危重症诊断证明书以及由医院出具的与诊断证明书相关的医嘱单，住院清单，入、出院小结，治疗病程；病理显微镜检查、血液检验及其他科学方法检验报告；</p>
        <p>（5）被保险人身故的，还应提供国家卫生行政部门认定的医疗机构、公安部门或其它相关机构出具的被保险人的死亡证明；</p>
        <p>（6）保险金申请人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。</p>
      </div>
    </div>
  </div>

</template>

<script>
import tdMixin from "@/mixins/td-mixin.js";
import keepTop from "@/mixins/keep-top.js";
import { getQueryString } from "../provider/common/util/common-util";
export default {
  name: "security-detail",
  mixins: [tdMixin, keepTop],
  data() {
    return {
      deadAmount: "", // 身故保障金金额
      fromId: "",
      ybFromId: "68635"
    };
  },
  created() {
    this.planId = getQueryString("planId", location.href) || "1029A01T01";
    let fromId =
      getQueryString("fromId", location.href) ||
      getQueryString("fromid", location.href) ||
      getQueryString("from_id", location.href) ||
      "";
    this.fromId = fromId.substring(0, 5);
    this.deadAmount =
      this.fromId === this.ybFromId || this.planId === "1029A01T02"
        ? "20"
        : "5";
  },
  mounted() {
    this.sendTD({ eventId: "BZXQY_BZXQY_LOAD" });
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/copy.scss";
</style>
